// extracted by mini-css-extract-plugin
export var balanceText = "styles-module--balanceText--ce01a";
export var critical = "styles-module--critical--85e85";
export var icon = "styles-module--icon--181f5";
export var info = "styles-module--info--b7312";
export var regular = "styles-module--regular--3dd03";
export var warningBanner = "styles-module--warningBanner--8753b";